import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {AuthenticationService} from './authentication.service';
import {Observable} from 'rxjs/Rx';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

const API_URL = environment.apiURL;

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

@Injectable()
export class BackendService {

  private static makeUrl(url: string): string {
    return API_URL + url;
  }

  public constructor(public http: HttpClient, protected auth: AuthenticationService) {
  }

  public get<T>(url: string, options?: IRequestOptions): Observable<T> {
    return this.http.get<T>(BackendService.makeUrl(url), options);
  }

  public post<T>(url: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.post<T>(BackendService.makeUrl(url), params, options);
  }

  public put<T>(url: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.put<T>(BackendService.makeUrl(url), params, options);
  }

  public delete<T>(url: string, options?: IRequestOptions): Observable<T> {
    return this.http.delete<T>(BackendService.makeUrl(url), options);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/backend.service.ts